import { Button, Stack, Typography } from "@mui/material";
import useLocales from "src/hooks/useLocales";

// ----------------------------------------------------------------------

type Props = { onClick: () => void };

export const TitleLabel = ({ onClick }: Props) => {
	const { translate } = useLocales();
	return (
		<Stack sx={{ p: 3 }} gap={1}>
			<Typography variant='h6'>{"Empieza creando tu primera aplicación"}</Typography>
			<Typography variant='body2' color='text.secondary'>
				{translate("app_settings.empty_app")}
			</Typography>
			<Stack flexDirection={"row"} justifyContent={"flex-end"} sx={{ mt: 1, mr: 2 }}>
				<Button variant='contained' onClick={onClick}>
					{translate("app_settings.add_app")}
				</Button>
			</Stack>
		</Stack>
	);
};

export default TitleLabel;
